import apiHttpClient from "./ApiHttpService";
import Vue from "vue";

export default class WorkRegistrationService {
  createWorkRegistration(model) {
    return apiHttpClient.post(
      "trs/mobile/WorkRegistration/createWorkRegistration",
      model
    );
  }
  deleteWorkRegistration(id) {
    return apiHttpClient.delete(
      `trs/mobile/WorkRegistration/deleteWorkRegistration/${id}`
    );
  }
  getWorkRegistration(id) {
    return apiHttpClient.get(
      `trs/mobile/WorkRegistration/editWorkRegistration/${id}`
    );
  }
  getWorkRegistrationMaxEndTime(workDayId, employeeId) {
    return apiHttpClient.get(
      `trs/mobile/WorkRegistration/getWorkRegistrationsMaxEndTime/${workDayId}/${employeeId}`
    );
  }
  updateWorkRegistration(model) {
    return apiHttpClient.post(
      "trs/mobile/WorkRegistration/updateWorkRegistration",
      model
    );
  }
  endWorkRegistration(workRegistrationId, endTime) {
    return apiHttpClient.post(
      `trs/mobile/WorkRegistration/endWorkRegistration/${workRegistrationId}/${endTime}`
    );
  }
  updateWorkRegistrationDates(model) {
    return apiHttpClient.put(
      "trs/mobile/WorkRegistration/updateWorkRegistrationDates",
      model
    );
  }
  updateWorkRegistrationDescription(id, description) {
    return apiHttpClient.put(
      `trs/mobile/WorkRegistration/updateWorkRegistrationDescription?id=${id}&description=${description}`,
      {}
    );
  }
  validateTimes(start, end) {
    if(end != null && start >= end) {
      Vue.prototype.$toast.add({
        severity: "warn",
        summary:
          "Ongeldige begin- en eindtijd / Invalid Start and End time",
        life: 3000,
        closable: false,
      });
      return false;
    }
    else 
    return true;
  }
  getEmployeeFunctionTimeRegime(workDate) {
    return apiHttpClient.get(
      `trs/mobile/WorkRegistration/getEmployeeFunctionTimeRegime/${workDate}`
    );
  }
  insertDefaultBreak(workDayId) {
    return apiHttpClient.post(
      `trs/mobile/WorkRegistration/insertDefaultBreak/${workDayId}`
    );
  }
  getEmployeeWorkStartByWorkslipId(workslipId) {
    return apiHttpClient.get(
      `trs/mobile/WorkRegistration/getEmployeeWorkStartByWorkslipId/${workslipId}`
    );
  }
}
